export default {
  namespaced: true,
  state: {
    currentStep: null,
    steps: null
  },
  mutations: {
    setCurrentStep(state, currentStep) {
      state.currentStep = currentStep
    },
    setSteps(state, steps) {
      state.steps = steps
    }
  },
  actions: {
    goToStep({ commit, state }, step) {
      return new Promise((resolve) => {
        state.steps.find((stepIterator) => stepIterator.id === step).status = 'current'

        // Updating Status
        state.steps.forEach((stepIterator) => {
          if (stepIterator.id < step) {
            stepIterator.status = 'complete'
          }
          if (stepIterator.id > step) {
            stepIterator.status = 'upcoming'
          }
        })

        commit('setCurrentStep', step)

        resolve()
      })
    },

    nextStep({ commit, state }) {
      const nextStep = state.currentStep + 1

      state.steps.find((step) => step.id === state.currentStep).status = 'complete'
      state.steps.find((step) => step.id === nextStep).status = 'current'

      commit('setCurrentStep', nextStep)
    },

    previousStep({ commit, state }) {
      const previousStep = state.currentStep - 1

      state.steps.find((step) => step.id === state.currentStep).status = 'upcoming'
      state.steps.find((step) => step.id === previousStep).status = 'current'

      commit('setCurrentStep', previousStep)
    },

    completeStep({ state }) {
      state.steps.find((stepIterator) => stepIterator.id === state.currentStep).status = 'complete'
    }
  },

  getters: {
    currentStep: (state) => {
      return state.currentStep
    },
    steps: (state) => {
      return state.steps
    }
  }
}
